import { createTheme } from '@mui/material/styles';

// Nexus brand ramp (mirrors web/public/brand/README.md) — dark, purple/silver.
export const nexusColors = {
  bg: '#0b0b13',
  bgElevated: '#131320',
  bgCard: '#15141f',
  line: 'rgba(255,255,255,0.09)',
  purple: '#8b3df0',
  purpleLight: '#b06bff',
  purpleDeep: '#6d28d9',
  silver: '#d3dae6',
  ink: '#f5f6fa',
  muted: 'rgba(245,246,250,0.66)',
  faint: 'rgba(245,246,250,0.42)',
};

export const theme = createTheme({
  palette: {
    mode: 'dark',
    background: { default: nexusColors.bg, paper: nexusColors.bgCard },
    primary: { main: nexusColors.purple, light: nexusColors.purpleLight, dark: nexusColors.purpleDeep },
    secondary: { main: nexusColors.silver },
    text: { primary: nexusColors.ink, secondary: nexusColors.muted },
    divider: nexusColors.line,
  },
  typography: {
    fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif',
    h1: { fontFamily: '"Space Grotesk", system-ui, sans-serif', fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontFamily: '"Space Grotesk", system-ui, sans-serif', fontWeight: 700, letterSpacing: '-0.015em' },
    h3: { fontFamily: '"Space Grotesk", system-ui, sans-serif', fontWeight: 600, letterSpacing: '-0.01em' },
    h4: { fontFamily: '"Space Grotesk", system-ui, sans-serif', fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage:
            'radial-gradient(1100px 480px at 82% -10%, rgba(139,61,240,0.20), transparent 60%),' +
            'radial-gradient(820px 460px at 6% 8%, rgba(176,107,255,0.12), transparent 55%)',
          backgroundAttachment: 'fixed',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10, paddingLeft: 20, paddingRight: 20 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
  },
});
